import React from "react";

function CareerPost({ key, post, description }) {
  return (
    <div className="relative bg-secondary-light dark:bg-secondary-dark font-Inter w-72 h-96 rounded-2xl ">
      <div className="absolute inset-4 shadow-xl bg-tertiary-light dark:bg-tertiary-dark  px-10 rounded-2xl ">
        <div className="relative flex flex-col items-center justify-between h-full">
          <div className="">
            <h1 className="text-2xl md:text-3xl text-sustally-violet font-semibold mb-5 mt-5">
              {post}
            </h1>
            <p className="opacity-75 mb-10">{description}</p>
          </div>
          <div className="transform transition duration-200 hover:scale-[102%] mb-10">
            <a
              aria-label="View Career Post"
              className="px-4 py-2 rounded-full btn-careerpost text-white bg-sustally-violet "
              href={"career/applicationForm"}
            >
              Apply Here
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CareerPost;
